export const CHALLENGE_ENUMS = {
  QUESTION_LIST: 'QUESTION_LIST',
  ANSWERED_QUESTIONS: 'ANSWERED_QUESTIONS',
  UNANSWERED_QUESTIONS: 'UNANSWERED_QUESTIONS',
  CURRENT_QUESTION: 'CURRENT_QUESTION',
  CLEARN_CHALLENGE_STATE: 'CLEAR_CHALLENGE_STATE'
};
